import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { City, useLocationStore } from '@entities/Location'

import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

import CitiesModal from './CitiesModal'
import ContactForm from './ContactForm'
import Requisites from './Requisites'
//import StoresWithMap from './StoresWithMap'

import styles from './styles.module.scss'

export default function ContactsPage () {
  const { t: tc } = useTranslation('contacts')
  const { t: ts } = useTranslation('seo')
  const { currentCity } = useLocationStore()
  const [ selectedCity, setSelectedCity ] = useState<City | null>(
    currentCity ?? null
  )
  const [ isCitiesModalOpen, setIsCitiesModalOpen ] = useState(false)

  return (
    <Container>
      <SEO
        title={ts('contacts.title', { brand: BRAND_NAME })}
        description={ts('contacts.description', { brand: BRAND_NAME })}
      />
      <Wrapper>
        <Breadcrumbs
          className={styles.breadcrumbs}
          links={[
            {
              title: tc('page'),
            },
          ]}
        />

        <div className={styles.container}>
          <div className={styles.content}>
            <h1 className={styles.title}>{tc('title')}</h1>

            {/* Always in touch section */}
            <section className={styles.alwaysInTouch}>
              <div className={styles.alwaysInTouch__left}>
                <h2 className={styles.alwaysInTouch__title}>
                  {tc('alwaysInTouch.title')}
                </h2>
                <p className={styles.alwaysInTouch__description}>
                  {tc('alwaysInTouch.description')}
                  <br />
                  {tc('alwaysInTouch.descriptionSecond')}
                </p>

                <div className={styles.contactInfo}>
                  <div className={styles.contactInfo__item}>
                    <div className={styles.contactInfo__icon}>
                      <img src="/icons/contacts/map-pin.svg" alt="" />
                    </div>
                    <p className={styles.contactInfo__text}>
                      {tc('alwaysInTouch.address')}
                    </p>
                  </div>

                  <div className={styles.contactInfo__item}>
                    <div className={styles.contactInfo__icon}>
                      <img src="/icons/contacts/mail.svg" alt="" />
                    </div>
                    <p className={styles.contactInfo__text}>
                      <a href={`mailto:${tc('alwaysInTouch.email')}`}>{tc('alwaysInTouch.email')}</a>
                    </p>
                  </div>

                  <div className={styles.contactInfo__item}>
                    <div className={styles.contactInfo__icon}>
                      <img src="/icons/contacts/phone.svg" alt="" />
                    </div>
                    <p className={styles.contactInfo__text}>
                      <a href={`tel:${tc('alwaysInTouch.phone')}`}>{tc('alwaysInTouch.phone')}</a>
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.alwaysInTouch__right}>
                <ContactForm />
              </div>
            </section>

            {/* Stores section */}
            {/* <StoresWithMap
              selectedCity={selectedCity}
              onCitySelectClick={() => setIsCitiesModalOpen(true)}
            /> */}

            {/* Cities Modal */}
            {isCitiesModalOpen && (
              <CitiesModal
                currentCity={selectedCity?.name ?? ''}
                onCitySelect={(city) => setSelectedCity(city)}
                onClose={() => setIsCitiesModalOpen(false)}
              />
            )}

            {/* Requisites section */}
            <Requisites />
          </div>
        </div>
      </Wrapper>
    </Container>
  )
}
